import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-plan-details',
  templateUrl: './plan-details.component.html',
  styleUrls: ['./plan-details.component.sass'],
})
export class PlanDetailsComponent implements OnInit {
  @Input() description: any;
  element: any = {};
  title = '';

  constructor(
    public dialogRef: MatDialogRef<PlanDetailsComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      title: string;
      element: any;
    }
  ) {
    if (data?.title) this.title = data.title;
    this.element = data.element;
    this.element.audits = this.element.audits.sort((a: any, b: any) => {
      return new Date(a.createdAt).getTime()- new Date(b.createdAt).getTime();
    })
  }

  ngOnInit(): void {}

  public close() {
    this.dialogRef.close();
  }

  public getAction(action: number) {
    switch (action) {
      case 1:
        return 'Inclusão';
      case 2:
        return 'Alteração';
      case 3:
        return 'Exclusão';
      default:
        return '';
    }
  }
}
